
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import * as actions from '../../../../actions/device.Action';
import CreateComponent from './create.component';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            checkbox: false
        }
    }

    onChange = (e) => {
        const value = e.target.value;

        this.setState({
            [e.target.name]: value
        });
    }

    onChangeCheckbox = (evt, data) => {
        this.setState({
            checkbox: data.checked
        });
      }
    

    onCreate = () => {
        const { firstName, lastName, checkbox } = this.state;

        const requestData = {
            firstName: firstName,
            lastName: lastName,
            checkbox: checkbox
        };

        fetch(`https://60fbca4591156a0017b4c8a7.mockapi.io/fakeData`, {
            method: "POST",
            body: JSON.stringify(requestData),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }).then(response => response.json())
            .then(json => {
                console.log(json);
                this.props.onClose();
            });
    }

    onClose = () => {
        this.props.onClose();
    }

    render() {
        return (
            <CreateComponent
                {...{
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    checkbox: this.state.checkbox
                }}
                onCreate={this.onCreate.bind(this)}
                onChange={this.onChange.bind(this)}
                onChangeCheckbox={this.onChangeCheckbox.bind(this)}
                onClose={this.onClose.bind(this)} />
        );
    }
}

function mapStateToProps(state) {
    return {
        device: state.deviceReducer.device
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

Create.displayName = 'Create';

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Create));